import IndicatorConfigModal from '@/components/Indicators/IndicatorConfigModal'
import ColorPickerField from '@/components/Indicators/ColorPickerField'
import SliderField from '@/components/Indicators/SliderField'

const STYLE_OPTIONS = [
  { value: 'solid', label: 'Sólido' },
  { value: 'dashed', label: 'Guiones' },
  { value: 'dotted', label: 'Puntos' },
]

export default function BollingerPanel({ config, onChange, onClose }) {
  const setValue = (patch) => onChange(patch)

  return (
    <IndicatorConfigModal title="Configuración Bollinger Bands" isOpen onClose={onClose}>
      <div className="space-y-3">
        <SliderField label="Período" value={config.period} min={5} max={100} step={1} unit="" onChange={(v) => setValue({ period: v })} />
        <SliderField label="Multiplicador" value={config.multiplier} min={0.5} max={5} step={0.1} unit="σ" onChange={(v) => setValue({ multiplier: v })} />
        <ColorPickerField label="Color" value={config.color} onChange={(v) => setValue({ color: v })} />
        <SliderField label="Grosor de línea" value={config.lineWidth} min={1} max={4} step={0.5} unit="px" onChange={(v) => setValue({ lineWidth: v })} />

        <div className="space-y-1">
          <span className="text-xs font-medium text-slate-700 dark:text-gray-200">Estilo de línea</span>
          <div className="grid grid-cols-3 gap-2">
            {STYLE_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                onClick={() => setValue({ lineStyle: opt.value })}
                className={`px-2 py-1.5 text-[11px] font-medium rounded-lg border transition-colors ${
                  config.lineStyle === opt.value
                    ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-300 dark:border-blue-700 text-blue-700 dark:text-blue-300'
                    : 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-700 text-slate-600 dark:text-gray-400 hover:bg-slate-50 dark:hover:bg-gray-700'
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </IndicatorConfigModal>
  )
}
